import React, { FunctionComponent } from 'react'
import { ViewStyle } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'
import { BodyText, Size as BodyTextSize } from '../bodyText/BodyText'
import { Title, Size as TitleSize } from '../title/Title'

const SummaryDetailContainer = styled.View`
  display: flex;
  flex-direction: column;
  width: 272px;
`

export type SummaryDetailProps = {
  label: string | React.ReactNode
  value: string | React.ReactNode
  sublabel?: string | React.ReactNode
  highlightValueAsWarning?: boolean
  customStyle?: ViewStyle
  customComponent?: React.ReactNode
  /**
   * EAP program category this row reports on, when the row is one of several
   * per-program session counts. Lets consumers identify the row matching the
   * current episode rather than assuming row order.
   */
  programCategory?: string
}

export const SummaryDetail: FunctionComponent<SummaryDetailProps> = ({
  label,
  value,
  sublabel,
  highlightValueAsWarning = false,
  customStyle,
  customComponent,
}) => {
  const { colors } = useTheme()
  let valueColor

  if (highlightValueAsWarning) {
    valueColor = colors.textWarning
  }

  return (
    <SummaryDetailContainer testID={tID('summary-detail')} style={customStyle}>
      {customComponent ? (
        customComponent
      ) : (
        <>
          <BodyText text={label} size={BodyTextSize.CAPTION} color={colors.textSecondary} />
          <Title text={value} size={TitleSize.SMALL} color={valueColor} />
          {sublabel && <BodyText text={sublabel} size={BodyTextSize.CAPTION} color={colors.textSecondary} />}
        </>
      )}
    </SummaryDetailContainer>
  )
}
